if(!customElements.get('ls-localization')) {
    customElements.define('ls-localization', class LsLocalization extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.id = crypto.randomUUID();
            this.button = this.querySelector('button');
            this.nav = this.querySelector('nav');
            this.navId = `ls-localization-nav-${this.id}`;

            this.button.setAttribute('aria-controls', this.navId);
            this.nav.setAttribute('id', this.navId);

            window.addEventListener('click', event => {
                // Handle button press
                if(this.isSameOrContained(event.target, this.button)) {
                    this.toggle();
                }
                // Handle light dismiss
                else if(
                    !this.nav.hasAttribute('inert') &&
                    !this.isSameOrContained(event.target, this.nav)
                ) {
                    this.dismiss();
                }
            });

            // Dismiss when hovering over mega menu
            window.addEventListener('mousemove', event => {
                if(document.querySelector('.is-active:is(dropdown-menu, mega-menu)')) {
                    this.dismiss();
                }
            });
        }

        toggle() {
            this.button.ariaExpanded = (this.button.ariaExpanded === 'false' ? 'true' : 'false');
            this.nav.toggleAttribute('inert');
        }

        dismiss() {
            this.button.ariaExpanded = 'false';
            this.nav.setAttribute('inert', '');
        }

        // Test if node is the same as another or contained by it
        isSameOrContained(source, target) {
            return target === source || target.contains(source);
        }
    });
}